import { type AdAudienceSignals, getAdsDataConfig } from './config';

/**
 * The only account country ads are shown to, as `GET /user` spells it: the
 * display name the backend's `Country.UNITED_STATES` resolves to, not an ISO
 * code. Mirrors `ADS_SUPPORTED_COUNTRY` in ml-scribe's
 * `advertisements/availability.py`.
 */
export const ADS_SUPPORTED_COUNTRY = 'United States';

/**
 * Whether the viewer could still be served an ad given what the caches say.
 * Fail-open: only a positive exclusion returns `false`, so an unloaded signal
 * keeps the request flowing and the server decides.
 */
export function mayBeInAdAudience(signals: AdAudienceSignals): boolean {
  return (
    signals.isOnPremBuild !== true &&
    signals.isInAdCountry !== false &&
    signals.isManaged !== true &&
    signals.isInTeam !== true &&
    signals.isFreeTier !== false
  );
}

/** {@link mayBeInAdAudience} over the app-injected signals. */
export function useMayBeInAdAudience(): boolean {
  return mayBeInAdAudience(getAdsDataConfig().useAudienceSignals());
}
